export default {
  it: {
    RecapSottoscrizioniPaziente: {
      rinnovo_stato_successo: "Rinnovo automatico {stato} con successo",
      attivato: "attivato",
      disattivato: "disattivato",
      data_fine_modificata: "Data di fine sottoscrizione modificata con successo",
      errore_generico: "Non è stato possibile completare l'operazione",
    },
  },
  en: {
    RecapSottoscrizioniPaziente: {
      rinnovo_stato_successo: "Auto-renewal successfully {stato}",
      attivato: "enabled",
      disattivato: "disabled",
      data_fine_modificata: "Subscription end date successfully updated",
      errore_generico: "The operation could not be completed",
    },
  },
};
